module.exports = __webpack_public_path__ + "static/img/zhinengbanner-m.05fb4b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhinengbanner-m.png
// module id = o07s
// module chunks = 0